import { ChannelService } from './../../../import/service/channel.service';
import { User } from '../../../user/models/user.type';
import { UserService } from './../../../user/services/user.service';
import { Component, OnInit } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { FieldConfig } from '../../../../utils/dynamic-form/form.type';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductService } from '../../service/product.service';
import { Product } from '../../model/product.type';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TippyDirective } from '@ngneat/helipopper';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CategoryService } from '../../../import/service/category.service';
import { BadgeModule } from 'primeng/badge';
import { StatusService } from '../../service/status.service';
import { ProductHelper } from '../../product/helper/productHelper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Util } from '../../../../utils/util';
import { ProductListEditComponent } from '../product-list-edit/product-list-edit.component';
import { ExportService } from '../../../../services/export/export.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Message} from 'primeng/message';
import { ShopService } from '../../../shop/service/shop.service';
import { Pagination, ProductQueryService } from '../../model/product-query-params';
import {FilterExtras } from '../../util/util';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [
    FormsModule,
    CardModule,
    TableModule,
    ButtonModule,
    TagModule,
    SelectModule,
    ReactiveFormsModule,
    InputTextModule,
    CommonModule,
    TippyDirective,
    BadgeModule,
    TranslateModule,
    AutoCompleteModule,
    Message,
    TooltipModule
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
  providers: [DialogService, TranslateService],
})
export class ProductListComponent implements OnInit {
  tags = [];
  form: FormGroup;
  filters = [];
  products: Product[];
  user: User = this.userService.getUser();
  loading: boolean = false;
  totalRecords: number;
  channels: any = [];
  rows: number = 100;

  headers = ProductHelper.productOperatorHeaders;

  fields: FieldConfig[] = ProductHelper.searchFilters;

  appliedFilters = {};
  categories = [];
  sellers = [];
  hasNext: boolean = false;
  brands = [];
  ref: DynamicDialogRef | undefined;
  searchFilters = {};
  selectedLocale: string;
  locales: any = [];

  selectedProducts: any[];
  selectAll = false;
  totalSelectedProducts = 0;
  
  constructor(
    private readonly productService: ProductService,
    private readonly userService: UserService,
    private readonly channelService: ChannelService,
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly categoryService: CategoryService,
    private readonly statusService: StatusService,
    private readonly exportService: ExportService,
    private readonly translate: TranslateService,
    private readonly shopService: ShopService,
    private readonly productQueryParamsService: ProductQueryService
  ) {}

  ngOnInit(): void {
    this.initializeFields();
    this.initForm();
    this.initLocales();
    this.initProducts();
  }

  private initializeFields(): void {
    this.fields[0].value = this.user?.defaultChannel;
    this.fields[0].options = this.user?.relatedChannels;
    this.productQueryParamsService.email = this.user?.email;
    this.productQueryParamsService.channel = this.channelService.getSelectedChannel()?.channelCode;
    this.searchFilters = this.productQueryParamsService.filters
    this.tags = this.productQueryParamsService.tags;
    this.rows = this.productQueryParamsService.pagination.pageSize;
    this.appliedFilters = this.productQueryParamsService.appliedFilters
    if (this.channelService.getSelectedChannel() === null) {
      this.channelService.setSelectedChannel(this.fields[0].value);
    } else {
      this.fields[0].value = this.channelService.getSelectedChannel();
    }
  }

  private initForm(): void {
    const searchValue = this.productQueryParamsService.searchKeyWord
    let elements = typeof searchValue === 'string' ? searchValue.trim().split(/\s+/) : [];
    elements = elements.filter(str => str.trim() !== '')
    this.form = new FormGroup({
      channel: new FormControl(this.fields[0].value),
      search: new FormControl(elements.length > 0 ? elements : ''),
    });
  }

  initCategories() {
    this.categoryService.getCategories().subscribe({
      next: (res) => {
        const categories = structuredClone(res);
        this.categories = this.categoryService.getCaterogyByLocale(
          categories,
          this.selectedLocale,
        );
      },
    });
  }

  initFacet(data: any, facetName: string, targetArray: any[]): void {
    if (data?.facets?.[facetName]) {
      const items = data.facets[facetName].map(item => {
        return { name: item, key: item };
      });
      targetArray.length = 0; // Clear array
      targetArray.push(...items); // Add new items
    }
  }

  initSellers() {
    this.shopService.getPaginatedShops("", 0).subscribe({
      next: (res) => {
        this.sellers = res['shops']
        this.hasNext = res['hasNext'] 
        this.loading = false;  
      }
    })
  }

  initBrands(data) {
    this.initFacet(data, 'brands', this.brands);
  }

  getProductList() {
    this.prepareQueryParams();
    this.loading = true;
    this.productService
      .getOperatorProductList(this.productQueryParamsService.get())
      .subscribe({
        next: this.handleProductListResponse.bind(this),
        error: this.handleProductListError.bind(this),
      });
  }

   private prepareQueryParams(): void {

    this.productQueryParamsService.channel ??= this.channelService.getSelectedChannel()?.channelCode;
    
    this.productQueryParamsService.locale = this.selectedLocale;
    this.productQueryParamsService.email = this.user?.email;

    if ( Object.keys(this.searchFilters).length != 0) {
      this.productQueryParamsService.addParams(this.searchFilters);
    }

    if ( Object.keys(this.appliedFilters).length != 0) {
      this.productQueryParamsService.appliedFilters = this.appliedFilters;
    }

    if(this.tags.length > 0) {
      this.productQueryParamsService.tags = this.tags;
    }
  }

  private handleProductListResponse(res: any): void {
    this.products = res.products;
    this.totalRecords = res.totalRecords;
    this.initCategories();
    this.initSellers();
    this.initBrands(res);
  }

  private handleProductListError(err: any): void {
    this.loading = false;
    this.products = [];
  }

  getRowClass(product, header) {
    let classes = '';
    
    if (product?.editorialCharter?.status === 'Modification requise' && header.id === 'editorialCharter') {
      classes += 'highlight-background-modification ';
    } else if (product?.editorialCharter?.status === 'En attente de vérification' && header.id === 'editorialCharter') {
      classes += 'highlight-background-verification ';
    }
    
    if (header.id === 'label' || header.id === 'category') {
      classes += 'underline-text';
    }
    
    return classes;
  }

  rowClick(event: MouseEvent, product) {
    if (globalThis.getSelection()?.toString()) {
      event.preventDefault();
      return;
    }
    this.router.navigate(['/operator/catalog/' + product.id]);
  }

  loadProducts(event: TableLazyLoadEvent) {
    this.updateQueryParamsFromEvent(event);
    this.getProductList();
  }

  private updateQueryParamsFromEvent(event: TableLazyLoadEvent): void {
    const currentPage = event.first / event.rows;
    let productQueryParams: Pagination = {
      offset: 0,
      orderDirection: '',
      pageSize: 0,
      orderColumn: '',
    };
    productQueryParams.offset = currentPage;
    productQueryParams.orderDirection = event.sortOrder == 1 ? 'asc' : 'desc';
    productQueryParams.pageSize = event.rows;
    productQueryParams.orderColumn = event.sortField;
    this.productQueryParamsService.pagination = productQueryParams;
    this.productQueryParamsService.locale = this.channelService.getDefaultLocal(
      this.productQueryParamsService.channel,
      this.channels,
    );
  }

  filterGlobal(event, type = null) {
    if (type == 'channel') {
      this.handleChannelFilter(event);
    } else if (type == 'input') {
      this.handleInputFilter();
    }
    this.getProductList();
  }

  private handleChannelFilter(event: any): void {
    this.fields[0].value = event;
    this.initLocales(event);
    this.productQueryParamsService.channel = event?.channelCode;
    this.channelService.setSelectedChannel(this.fields[0].value);
    this.selectedLocale = this.channelService.getDefaultLocal(
      this.productQueryParamsService.channel,
      this.channels,
    )
  }

  private handleInputFilter(): void {
    this.productQueryParamsService.pagination.offset = 0;
    if(this.form.get('search')?.value == null) {
      this.productQueryParamsService.searchKeyWord = "";
    } else {
      this.productQueryParamsService.searchKeyWord = this.form.get('search')?.value.join(' ').replaceAll('\t', '');
    }
   
  }

  initProducts(): any {
    this.channelService.getChannels().subscribe({
      next: (res) => {
        this.channels = res;
        this.selectedLocale ??= this.channelService.getDefaultLocal(
          this.channelService.getSelectedChannel()?.channelCode,
          this.channels,
        );
      
        this.getProductList();
      },
      error: (err) => {
        this.loading = false;
        this.products = [];
      },
    });
  }

  initFilters() {
    this.filters = [
      this.createFilter(
        'statusTree',
        'status',
        'filters.status',
        this.statusService.getStatus(),
      ),
      this.createFilter(
        'categoryTree',
        'category',
        'filters.category',
        this.categories,
      ),
      this.createFilter(
        'select',
        'brands',
        'filters.brand',
        this.brands,
        true,
        'name',
      ),
      this.createFilter(
        'list',
        'shopMultiple',
        'filters.seller',
        this.sellers,
        false,
        'shopCode',
        {hasNext: this.hasNext,
        selectionMode: 'multiple',
        display: 'shopNameWithChannel'}
      ),
      this.createFilter('date', 'lastImportDate', 'filters.lastImport'),
    ];
  }

  private createFilter(type: string,
      name: string,
      header: string,
      values?: any[],
      search?: boolean,
      key?: string,
      extras?: FilterExtras): any {
    const filter: any = {
      type,
      name,
      header,
    };
    
    if (values) filter.values = values;
    if (search) filter.search = search;
    if (key) filter.key = key;
    if (extras?.display) filter.display = extras.display;
    if (extras?.hasNext) filter.hasNext = extras.hasNext;
    if (extras?.selectionMode) filter.selectionMode = extras.selectionMode;
    
    return filter;
  }

  openFilterModal() {
    Util.openFilterModal(
      this.dialogService,
      this.translate,
      this,
      this.initFilters,
      this.getProductList
    );
  }

  
  resetFilters() {
    this.productQueryParamsService.resetFilters()
    this.productQueryParamsService.appliedFilters = {};
    this.productQueryParamsService.tags = []
    Util.resetFilters(this, this.getProductList);
  }

  removeFilter(value, parent) {
    this.tags = this.tags.filter((tag) => tag.name !== value);
    delete this.searchFilters[value];
    if (parent) {
      this.appliedFilters[parent] = this.appliedFilters[parent].filter(
        (filter) => filter.group !== value,
      );
      if (this.appliedFilters[parent].length === 0) {
        delete this.appliedFilters[parent];
      }
    } else {
      delete this.appliedFilters[value];
    }
    this.productQueryParamsService.resetFilters()
    this.productQueryParamsService.appliedFilters = this.appliedFilters;
    this.productQueryParamsService.tags = this.tags
    this.getProductList();
  }

  getSeverity(status: string) {
    return Util.getSeverity(status);
  }

  isPublicationStatusErrors(product) {
    return product?.publicationStatusErrors.length > 0 ? product?.publicationStatusErrors[0].message != "" : false;
  }
  getSeverityForPublicationStatus(product) {
    return Util.getSeverityForPublicationStatus(product?.status, this.isPublicationStatusErrors(product));
  }

  getPublicationStatusErrors(product) {
    return product?.publicationStatusErrors
              .map((error) => Util.buildMessage('-', error, ['level', 'attributeCode', 'message']))
  }

  getColumnMinWidth(id: string): string {
    const widthMap = {
      'product': '100px',
      'label': '150px',
      'editorialCharter': '150px',
      'default': 'auto'
    };
    
    return widthMap[id] ?? widthMap['default'];
  }

  initLocales(channel = null) {
    channel ??= this.channelService.getSelectedChannel();
    this.channelService.getLocales(channel).subscribe({
      next: (res: any) => {
        this.locales = res.locales;
        this.selectedLocale = this.productQueryParamsService.locale ?? this.locales?.[0];
      },
    });
  }

  updateLocale(event) {
    this.selectedLocale = event;
    this.channelService.setSelectedLocale(event);
    this.getProductList();
  }

  selectAllProducs() {
    this.selectAll = true;
    this.totalSelectedProducts = Math.min(this.totalRecords, 50000);
    this.selectedProducts = structuredClone(this.products);
  }

  removeSelection() {
    this.selectedProducts = [];
    this.selectAll = false;
  }

  openEditProductDialog() {
    let distinct: Set<string> = new Set();
    for (const p of this.selectedProducts) {
      distinct.add(p.category);
    }
    
    this.ref = this.dialogService.open(ProductListEditComponent, {
      header: 'Modification en masse',
      data: {
        categories: this.categories,
        totalSelected: this.selectedProducts?.length,
        differentCategories: distinct.size,
      },
      dismissableMask: true,
      width: '80vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });
  }

  onSelectionChange(event) {
    this.selectedProducts = event;
    this.selectAll = false;
  }

  exportProducts() {
    const data = this.prepareExportData();
    
    this.exportService.downloadFileProduct(data).subscribe({
      next: (response) => Util.handleExportSuccess(response),
      error: Util.handleExportError,
    });
  }

  private prepareExportData(): any {
    let data: any = {};
    
    if (this.productQueryParamsService.get().pagination?.orderColumn) {
      data['orderColumn'] = this.productQueryParamsService.get().pagination?.orderColumn;
      data['orderDirection'] = this.productQueryParamsService.get().pagination?.orderDirection;
    }
    
    if (this.selectAll) {
      data = { ...data, ...this.productQueryParamsService.get().filters };
    } else {
      data['ids'] = this.selectedProducts.map((product) => product.id);
    }
    
    return {...data, selectAll: this.selectAll, channel : this.productQueryParamsService.channel};
  }


  pasteEvent(filter: any) {
    Util.pasteEvent(this.form, filter);
  }

  onFilterKeydown(event: KeyboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    if (event.key === 'Enter') {
      // l'AutoComplete a déjà ajouté le token; on vide le champ (bug PrimeNG en mode multiple)
      (event.target as HTMLInputElement).value = '';
      return;
    }
    Util.addTokenOnSeparatorKey(event, control);
  }

  onFilterPaste(event: ClipboardEvent, filter: any) {
    const control = this.form.get(filter.name);
    if (Util.pasteTokens(event, control)) {
      this.filterGlobal(null, 'input');
    }
  }

  resetSearch() {
    this.form.get(this.fields[1].name).reset();
    this.handleInputFilter();
    this.getProductList();
  }
}
